// extracted by mini-css-extract-plugin
export var progressContainer = "_gi-0";